import { CentreData, MappingData } from "types/models/support/SupportApp";
import { AppActions } from "../../types";
import { GET_Centre, GET_Mapping, SET_Centre_DATA, SET_Mapping_DATA } from "types/actions/Support.action";

export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

// Initial state for centre
const initialState: {
  currentCentre: CentreData | null; 
  centre: CentreData[]; 
  centreCount: number;
  currentMapping: MappingData | null; 
  mapping: CentreData[]; 
  mappingCount: number;
} = {
  currentCentre: null,
  centre: [],
  centreCount: 0,
  currentMapping: null,
  mapping: [],
  mappingCount: 0,
};

const Support = (state = initialState, action: AppActions) => {
  switch (action.type) {

    // Centre-related actions
    case GET_Centre:
      return {
        ...state,
        centre: action.payload.centre,
        centreCount: action.payload.centreCount,
      };
    case SET_Centre_DATA:
      return {
        ...state,
        currentCentre: action.payload,
      };

    // mapping-related actions
    case GET_Mapping:
      return {
        ...state,
        mapping: action.payload.mapping,
        mappingCount: action.payload.mappingCount,
      };
    case SET_Mapping_DATA:
      return {
        ...state,
        currentMapping: action.payload,
      };

    default:
      return state;
  }
};

export default Support;
